export const convertMinutesInHourAndMinutes = (minutes: number) => {
  const durationHours = Math.floor(minutes / 60);
  const durationMinutes = minutes % 60;
  return {
    durationHoursString: ('0' + durationHours).slice(-2),
    durationMinutesString: ('0' + durationMinutes).slice(-2),
  };
};
